export enum SupportedLanguageEnum {
  IT = 'it',
  EN = 'en'
}
